import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Heart, Loader2 } from 'lucide-react';
import { bc } from '../lib/api';
import { useAuth } from '../lib/auth';
import CatalogCard from '../components/CatalogCard';

export default function Wishlist() {
  const { user } = useAuth();
  const [items, setItems] = useState(null);
  useEffect(() => { if (user) bc.wishlist().then(d => setItems(d.items)).catch(() => setItems([])); }, [user]);
  if (!user) return <div className="p-10 text-center" data-testid="wishlist-login">Sign in to see your wishlist.</div>;
  return (
    <div className="max-w-7xl mx-auto px-4 md:px-6 py-6 space-y-4" data-testid="wishlist-page">
      <h1 className="font-heading font-black text-3xl flex items-center gap-2"><Heart className="w-7 h-7 text-[#E53935]"/>My wishlist</h1>
      {!items ? <Loader2 className="w-6 h-6 animate-spin"/> : items.length === 0 ? (
        <p className="text-ink/60" data-testid="wishlist-empty">Nothing saved yet. <Link to="/catalog" className="underline">Explore products</Link></p>
      ) : <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">{items.map(p => <CatalogCard key={p.id} p={p}/>)}</div>}
    </div>
  );
}
